import { Component, OnInit, ViewChild, Input, Injectable, Inject } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ResponseModal2Component } from '../../components/response-modal2/response-modal2.component';
import { AccountStatusService } from './../../services/account-status/account-status.service';
import { ToasterModule, ToasterService, Toast, ToasterConfig } from 'angular5-toaster';
import { StorageService } from '../../services/storage.service';
import { User } from '../../models/user';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import { ENPOINT } from './../../services/endpoint';
import { TranslateService } from '@ngx-translate/core';
import { NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { SearchInvoicesService } from '../../services/search-invoices.service';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

const I18N_VALUES = {
  'es': {
    weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
  },
  'en': {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  }
};

@Injectable()
export class I18n {
  lang; language;
  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
  ) {
    this.lang = this.storage.get('LOCAL_STORAGE');

    if (this.lang === 'es') {
      this.language = this.lang;
    } else {
      this.language = 'en';
    }
  }
}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}

@Component({
  selector: 'app-searchinvoices', 
  templateUrl: './search-invoices.component.html',
  styleUrls: ['./search-invoices.component.scss'],
  providers: [NgbActiveModal, AccountStatusService,
    I18n, {  provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})
export class SearchInvoicesComponent implements OnInit {
  @ViewChild('mydatatable') table: any;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  private basePath;
  public user: User;
  rows: any = [];
  selected = [];
  facturas;
  rol;
  usuario;
  rfc;
  userId;
  sociedad;
  proveedores;
  proveedorFilter;
  busyBusqueda: boolean = false;
  emailEnviado: string = "";

  fechaInput;

  arrayPaths: Array<any> = [];
  stringEmail: string = 'victor@glouu.com';
  public form: FormGroup;
  invalidEmail: boolean = false;
  tituloEnvioCorreo;

  proveedores$: Observable<any>;
  proveedoresLoading = false;
  proveedorinput$ = new Subject<string>();

  fechasValidas: boolean = false;
  emptyFile: boolean = false;
  select: boolean = false;
  toastMessage;
  toastRangoFechasValido;

  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });

  consulta = {
    rfcConsulta: null,
    remisionConsulta: null,
    correo: '',
    userId: ''
  }

  public error = null;
  camposVacios: boolean = false;


  constructor(
    private translate: TranslateService,
    private storageService: StorageService,
    private facturaRemService: SearchInvoicesService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private accountStatus: AccountStatusService,
    private toasterService: ToasterService,
    public activeModal: NgbActiveModal,
    private router: Router
  ) {
    this.translate.get('texto.NoHayFacturas').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

    this.translate.get('texto.especificarRangoFechas').subscribe(
      text => {
        this.toastMessage = text;
      });

    this.translate.get('texto.rangoFechasValido').subscribe(
      text => {
        this.toastRangoFechasValido = text;
      });
      this.translate.get('texto.informacionEnviada').subscribe(
        text => {
          this.tituloEnvioCorreo = text;
      });
  }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.rol = this.user.rol;
    if (this.rol === 2) {
      this.consulta.rfcConsulta = this.user.rfc;
    }
    let emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    this.form = this.formBuilder.group({
      correo: ['',  Validators.compose([Validators.required,
        Validators.pattern(emailregex),
        Validators.minLength(1)])]
    });
  }


  consultaFacturas() {
    this.selected = [];
    this.busyBusqueda = true;
    let fecha = (<HTMLInputElement>document.getElementById('fecha')).value;

    if (this.consulta.rfcConsulta != null) 
      this.consulta.rfcConsulta = (this.consulta.rfcConsulta).toUpperCase();
    
    // console.log(this.consulta.rfcConsulta);
    if (this.consulta.remisionConsulta == null
      || this.consulta.rfcConsulta == null
      || fecha == '') {
      this.camposVacios = true;
    } else {
      this.camposVacios = false;
    }

    if (this.user.rol == 2) {
      this.userId = this.user.userId;
    } else {
      this.userId = null;
    }

    if (!this.camposVacios) {
      let folio = this.consulta.remisionConsulta;
      let rfc = this.consulta.rfcConsulta;
      // Llamada de servicio
      this.facturaRemService.obtenerFacturasRemision(fecha, folio, rfc, this.userId).subscribe(
        data => {
          // console.log(data);
          this.busyBusqueda = false;
          this.rows = data.zte_ext_facturas;
        },
        error => {
          if (error.status === 401) {
            this.storageService.openLogout();
          } else {
            // console.log(error);
          }
          console.log(error);
          this.error = error;
          this.busyBusqueda = false;
        }
      )
    } else {
      this.busyBusqueda = false;
    }

  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  // onDateSelectFecha(e) {
  //   this.fechaInput = (<HTMLInputElement>document.getElementById('fecha')).value;
  //   console.log(this.fechaInput);
  // }

  keyUpDatePicker(e) {
    e.target.value = '';
    // this.fechaInicialInput = (<HTMLInputElement>document.getElementById('fechai')).value;
    // this.fechaFinalInput = (<HTMLInputElement>document.getElementById('fechaf')).value;

    // if (this.fechaInicialInput == undefined || this.fechaInicialInput == '') {
    //   this.sinFechaI = true;
    //   this.rangoFecha = false;
    // }
    // if (this.fechaFinalInput == undefined || this.fechaFinalInput == '') {
    //   this.sinFechaF = true;
    //   this.rangoFecha = false;
    // }
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
    if (this.selected.length !== 0) {
      this.select = true;
    } else {
      this.select = false;
    }
    // console.log(this.selected);
  }

  enviar() {
    this.busyBusqueda = true;
    let mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    let band: boolean = true;
    let validE = this.consulta.correo.split(",");

    validE.forEach(element => {
      element = element.trim();
      if (element.match(mailformat)) {
        band = true;
      }
      else {
        band = false;
      }
    });

    if (!band) {
      this.invalidEmail = true;
      this.busyBusqueda = false;
      return false;
    } else {
      this.invalidEmail = false;
      if (this.selected.length != 0) {
        this.emptyFile = false;
        this.stringEmail = this.consulta.correo;
        // console.log(this.selected);
        this.facturaRemService.enviarFacturasEmail(this.selected, this.stringEmail.split(","), true,true,true, null).subscribe(
          data => {
            // console.log(data);
            if(data.mensaje == 'Email enviado'){
              this.busyBusqueda = false;
              this.emailEnviado = data.mensaje;
              setTimeout(() => {
                this.activeModal.close();  
              }, 2000);
                const modalRef = this.modalService.open(ResponseModal2Component, { centered: true, keyboard: false, backdrop: 'static' });
                modalRef.componentInstance.titulo = this.tituloEnvioCorreo;
                modalRef.componentInstance.mensaje1 = data.mensaje;
              // this.busyBusqueda = false;
              // this.emailEnviado = data.mensaje;
              // setTimeout(() => {
              //   this.emailEnviado = ""
              // }, 2000);
            }
          },
          error => {
            if (error.status === 401) {
              this.storageService.openLogout();
            } else {
              // console.log(error);
            }
            console.log(error);
          }
        )
      } else {
        this.busyBusqueda = false;
        this.emptyFile = true;
      }
    }
  }


  getFacturas() {
    this.busyBusqueda = true;
  }

  descargarPdf(pdf) {
    if (pdf != '') {
      this.accountStatus.obtenerPDF(pdf, null);
    } else {
      // console.log('El registro no contiene archivo PDF.');
    }
  }


  descargarXml(xml) {
    if (xml != '') {
      this.accountStatus.obtenerXML(xml,true);
    } else {
      // console.log('El registro no contiene archivo XML.');
    }
  }

  /* descargarPdf(index) {
    const docPdf = this.facturas[index].pdf;
    const srcFile = docPdf;
    console.log(srcFile);
    const urlPdf = this.basePath + 'master-factura/obtener-pdf';
    console.log(urlPdf);

    if (srcFile) {
      const srcB64 = btoa(srcFile);
      console.log(srcB64);

      const win = window.open(urlPdf + '?ruta=' + srcB64, '_blank');
      if (win) {
        win.focus();
      } else {
        alert('Por favor activa los popups en tu navegador');
      }
    } else {
      console.log('El registro no contiene archivo PDF.');
    }
  } */


  /* descargarXml(index) {
    const docXml = this.facturas[index].xml;
    const srcFile = docXml;
    console.log(srcFile);
    const urlXml = this.basePath + 'master-factura/obtener-xml';
    console.log(urlXml);

    if (srcFile) {
      const srcB64 = btoa(srcFile);
      console.log(srcB64);

      const win = window.open(urlXml + '?ruta=' + srcB64, '_blank');
      if (win) {
        win.focus();
      } else {
        alert('Por favor activa los popups en tu navegador');
      }
    } else {
      console.log('El registro no contiene archivo XML.');
    }
  } */


}



// WEBPACK FOOTER //
// ./src/app/pages/search-invoices/search-invoices.component.ts